// on_select_callback(selection, input): callback received the original object selected (from the result of location iq)
// return promise to be loaded
// load script from https://tarekraafat.github.io/autoComplete.js/
import autoComplete from '@tarekraafat/autocomplete.js';

const autoCompleteLocationIq = function(config = {
  selector: '',
  placeHolder: '',
  apiKey: '',
  on_select_callback: null,
  countryCode: 'FR,BE,CH,AD',
  search: 'full',
}) {
  if (document.querySelector(`.autoComplete_wrapper > ${config.selector}`)) {
    return;
  }

  function transformDisplay(item) {
    if (item.address) {
      let city = item.address.city || '';
      const houseNumber = item.address.house_number || '';
      let address = houseNumber + ' ' + (item.address.road || '');
      const postcode = item.address.postcode || '';
      const type = item.type;
      if (type === 'city' || type === 'village' || type === 'town') {
        city = item.address.name;
        address = '';
      } else if (type === 'locality' || item.class === 'highway') {
        city = item.address.city;
        address = item.address.name;
      }
      city = city.toUpperCase();
      item.result = { address, postcode, city };
      item.display = address + (address ? ', ' : '') + postcode + ' ' + city;
    }
  }

  const limit = 5;
  const countryCode = config.countryCode;
  let tag = 'highway,place:house,place:city,place:town,place:village';
  if (config.search === 'city') {
    tag = 'place:city,place:town,place:village';
  }

  const urlAutocomplete = 'https://api.locationiq.com/v1/autocomplete.php?key=' + config.apiKey +
      '&limit=' + limit +
      `&accept-language=${window.currentLocale}&countrycodes=${countryCode}` +
      '&tag=' + tag +
      '&dedupe=1&q=';
  const cacheRequest = {};
  return new Promise((resolve) => {
    // eslint-disable-next-line new-cap
    const autoCompleteJS = new autoComplete({
      selector: config.selector,
      placeHolder: config.placeHolder,
      debounce: 500,
      threshold: 3,
      diacritics: false,
      resultsList: { class: 'autocomplete-address-result' },
      resultItem: {
        element: (item) => {
          item.setAttribute('data-action', 'click->marketplace--search-animation#handleResultOnClick');
        },
      },
      // wrapper: false,
      data: {
        src: async(query) => {
          if (!query) {
            return;
          }
          if (cacheRequest[query]) {
            return cacheRequest[query];
          }
          try {
            const source = await fetch(urlAutocomplete + query);
            const data = await source.json();
            data.forEach(transformDisplay);
            cacheRequest[query] = data;
            return data;
          } catch (error) {
            return error;
          }
        },
        keys: ['display'],
        cache: false,
      },
      query: (input) => {
        return input.replaceAll(/\s+/g, ' ').trim();
      },
      searchEngine: function(query, record) {
        return record;
      },
      events: {
        input: {
          selection: (event) => {
            if (event.detail.event.keyCode !== 13) {
              const selection = event.detail.selection.value;
              autoCompleteJS.input.value = selection.display;
              if (typeof (config.on_select_callback) === 'function') {
                config.on_select_callback(selection, autoCompleteJS.input);
              }
            }
          },
        },
      },
    });
    resolve(autoCompleteJS);
  });
};

export { autoCompleteLocationIq };
